import React, { useReducer, useEffect } from 'react';
import './app.css';

// Reducer i početni state
const initialState = {
  name: '',
  municipality_name: '',
  municipality_type: '',
  entity_canton: '',
  address: '',
  mayor_name: '',
  municipality_email: '',
  municipality_website: '',
  contact_person_name: '',
  contact_person_position: '',
  contact_person_email: '',
  contact_person_phone: '',
  population_total: '',
  area_km2: '',
  settlements_count: '',
  registered_businesses_total: '',
  new_businesses_last_year: '',
  employees_total: '',
  main_industries: '',
  development_strategy: false,
  strategy_year: '',
  admin_employees_total: '',
  e_services_count: '',
  internal_audit: false,
  internal_audit_contact: '',
  fuk_coordinator: false,
  fuk_coordinator_info: '',
  youth_council: false,
  gender_equality_commission: false,
  environmental_council: false,
  other_councils_info: '',
  sustainability_activities_count: '',
  budget_total: '',
  declaration_accepted: false,
  responsible_person_name: '',
  responsible_person_position: '',
  declaration_date: '',
  signature_file: ''
};

function reducer(state, action) {
  return { ...state, [action.name]: action.value };
}

// Komponente van glavne funkcije
function InputField({ label, name, value, onChange, type = 'text' }) {
  return (
    <div>
      <label>{label}</label>
      <input type={type} name={name} value={value} onChange={onChange} />
    </div>
  );
}

function CheckboxField({ label, name, checked, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <input type="checkbox" name={name} checked={checked} onChange={onChange} />
      <label>{label}</label>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="section">
      <h3 className="section-title">{title}</h3>
      {children}
    </div>
  );
}

// Glavna komponenta
export default function ProfilePage() {
  const [profile, dispatch] = useReducer(reducer, initialState);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    dispatch({ name, value: type === 'checkbox' ? checked : value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validacija obaveznih polja
  for (let key in profile) {
    if (profile[key] === '' || profile[key] === null || profile[key] === undefined) {
      // Dozvoljavamo boolean vrijednosti da ostanu netaknute
      if (typeof profile[key] === 'boolean') continue;

      alert(`Molimo popunite polje: ${key}`);
      return;
    }
  }

  console.log('Šaljem podatke na backend:', profile);
  try {
    const token = localStorage.getItem('token');
    const response = await fetch('https://nagradjivanje-api.revicon.info/profile', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(profile)
    });

    if (response.ok) {
      alert('Podaci uspješno sačuvani!');
    } else {
      const errorData = await response.json();
      console.error('Greška prilikom slanja:', errorData);
      alert('Došlo je do greške prilikom čuvanja podataka.');
    }
  } catch (error) {
    console.error('Network greška:', error);
    alert('Greška u mrežnoj komunikaciji!');
  }
};


useEffect(() => {
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('https://nagradjivanje-api.revicon.info/profile', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Napuni reducer sa podacima iz baze
        Object.keys(data).forEach(key => {
          dispatch({ name: key, value: data[key] ?? '' });
        });
      } else {
        console.error('Greška prilikom dohvaćanja profila.');
      }
    } catch (err) {
      console.error('Network greška prilikom dohvaćanja profila:', err);
    }
  };

  fetchProfile();
}, []);


return (
  <div className="layout">


    <main className="content-area">
      <div className="form-container">
        <div className="profile-card">
          <h2 className="text-center text-3xl mb-8" style={{ color: '#2b6cb0' }}>
            Upitnik za lokalne zajednice
          </h2>

          <form onSubmit={handleSubmit}>
          <Section title="Osnovni identifikacioni podaci">
            <div className="form-grid">
              <InputField label="Naziv profila" name="name" value={profile.name} onChange={handleChange} />
              <InputField label="Naziv lokalne zajednice" name="municipality_name" value={profile.municipality_name} onChange={handleChange} />
              <InputField label="Vrsta jedinice (općina / grad)" name="municipality_type" value={profile.municipality_type} onChange={handleChange} />
              <InputField label="Entitet / Kanton" name="entity_canton" value={profile.entity_canton} onChange={handleChange} />
              <InputField label="Adresa sjedišta" name="address" value={profile.address} onChange={handleChange} />
              <InputField label="Naziv načelnika/gradonačelnika" name="mayor_name" value={profile.mayor_name} onChange={handleChange} />
              <InputField label="Kontakt e-mail općine/grada" name="municipality_email" value={profile.municipality_email} onChange={handleChange} />
              <InputField label="Web stranica općine/grada" name="municipality_website" value={profile.municipality_website} onChange={handleChange} />
            </div>
          </Section>

          <Section title="Osoba za kontakt (zadužena za prijave)">
            <div className="form-grid">
              <InputField label="Ime i prezime" name="contact_person_name" value={profile.contact_person_name} onChange={handleChange} />
              <InputField label="Pozicija/funkcija" name="contact_person_position" value={profile.contact_person_position} onChange={handleChange} />
              <InputField label="Kontakt e-mail" name="contact_person_email" value={profile.contact_person_email} onChange={handleChange} />
              <InputField label="Telefon" name="contact_person_phone" value={profile.contact_person_phone} onChange={handleChange} />
            </div>
          </Section>

          <Section title="Demografski i opći podaci">
            <div className="form-grid">
              <InputField label="Ukupan broj stanovnika" name="population_total" value={profile.population_total} onChange={handleChange} type="number" />
              <InputField label="Površina (u km²)" name="area_km2" value={profile.area_km2} onChange={handleChange} type="number" />
              <InputField label="Broj naseljenih mjesta / mjesnih zajednica" name="settlements_count" value={profile.settlements_count} onChange={handleChange} type="number" />
            </div>
          </Section>

          <Section title="Privreda i infrastruktura">
            <div className="form-grid">
              <InputField label="Broj registrovanih poslovnih subjekata (ukupno)" name="registered_businesses_total" value={profile.registered_businesses_total} onChange={handleChange} type="number" />
              <InputField label="Broj novoosnovanih u posljednjoj godini" name="new_businesses_last_year" value={profile.new_businesses_last_year} onChange={handleChange} type="number" />
              <InputField label="Broj zaposlenih" name="employees_total" value={profile.employees_total} onChange={handleChange} type="number" />
              <InputField label="Najznačajnije privredne djelatnosti (do 3)" name="main_industries" value={profile.main_industries} onChange={handleChange} />
              <CheckboxField label="Postoji li razvojna strategija?" name="development_strategy" checked={profile.development_strategy} onChange={handleChange} />
              <InputField label="Godina donošenja strategije" name="strategy_year" value={profile.strategy_year} onChange={handleChange} type="number" />
            </div>
          </Section>

          <Section title="Uprava i digitalne usluge">
            <div className="form-grid">
              <InputField label="Broj zaposlenih u administraciji" name="admin_employees_total" value={profile.admin_employees_total} onChange={handleChange} type="number" />
              <InputField label="Broj dostupnih e-servisa za građane" name="e_services_count" value={profile.e_services_count} onChange={handleChange} type="number" />
              <CheckboxField label="Postoji li odjel interne revizije?" name="internal_audit" checked={profile.internal_audit} onChange={handleChange} />
              <InputField label="Kontakt interne revizije" name="internal_audit_contact" value={profile.internal_audit_contact} onChange={handleChange} />
              <CheckboxField label="Postoji li FUK koordinator?" name="fuk_coordinator" checked={profile.fuk_coordinator} onChange={handleChange} />
              <InputField label="FUK koordinator info (ime-email)" name="fuk_coordinator_info" value={profile.fuk_coordinator_info} onChange={handleChange} />
            </div>
          </Section>

          <Section title="Participacija i održivost">
            <div className="form-grid">
              <CheckboxField label="Postoji vijeće mladih" name="youth_council" checked={profile.youth_council} onChange={handleChange} />
              <CheckboxField label="Postoji komisija za ravnopravnost spolova" name="gender_equality_commission" checked={profile.gender_equality_commission} onChange={handleChange} />
              <CheckboxField label="Postoji savjet za okoliš" name="environmental_council" checked={profile.environmental_council} onChange={handleChange} />
              <InputField label="Ostala participativna tijela (navesti koja)" name="other_councils_info" value={profile.other_councils_info} onChange={handleChange} />
              <InputField label="Broj realizovanih ekoloških aktivnosti (2 godine)" name="sustainability_activities_count" value={profile.sustainability_activities_count} onChange={handleChange} type="number" />
            </div>
          </Section>

          <Section title="Finansije">
            <InputField label="Ukupan budžet lokalne zajednice (posljednja godina)" name="budget_total" value={profile.budget_total} onChange={handleChange} type="number" />
          </Section>

          <Section title="Završna izjava">
            <div className="form-grid">
              <CheckboxField label="Izjavljujemo da su svi podaci tačni" name="declaration_accepted" checked={profile.declaration_accepted} onChange={handleChange} />
              <InputField label="Ime i prezime odgovorne osobe" name="responsible_person_name" value={profile.responsible_person_name} onChange={handleChange} />
              <InputField label="Funkcija" name="responsible_person_position" value={profile.responsible_person_position} onChange={handleChange} />
              <InputField label="Datum" name="declaration_date" value={profile.declaration_date} onChange={handleChange} type="date" />
              <InputField label="Import file-a ?" name="signature_file" value={profile.signature_file} onChange={handleChange} />
            </div>
          </Section>

          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <button type="submit">Spasi sve podatke</button>
          </div>

        </form>
      </div>
    </div></main></div>
  );
}
